import React,{useState,useEffect} from "react";
import { isMobile } from "react-device-detect";
import DpstOdrCrdtApi from "Apis/DpstOdrCrdtApi";
import MbpAthnTknCrtRqstApi from "Apis/MbpAthnTknCrtRqstApi";
import { navigateByService } from "Utils/navigationService";

const BILLGATE_PROTOCOL = process.env.REACT_BILLGATE_PROTOCOL;
const BILLGATE_PROTOCOL_QUOTED = '"' + BILLGATE_PROTOCOL + '"';
const BILLGATE_TARGET = "https_pay";

const isMacDesktop = !isMobile && /Mac/i.test(navigator.platform || navigator.userAgent);
const useInlinePaymentFlow = isMobile || isMacDesktop;
const BILLGATE_VIEW_TYPE = useInlinePaymentFlow ? "submit" : "popup";

const openPaymentUrl = (url: string, windowName: string) => {
    if (useInlinePaymentFlow) {
        window.location.assign(url);
        return;
    }

    window.open(
        url,
        windowName,
        "width=500,height=700,resizable=yes,scrollbars=yes,status=0,toolbar=0"
    );
};

const emitDpstApiMessage = (code: string, message: string) => {
    try {
        window.dispatchEvent(
            new CustomEvent("dpst-api-message", {
                detail: { code, message },
            })
        );
    } catch {
        // ignore event dispatch errors
    }
};

const openMbpAthnWindow = async (athnPrpsCd:string = "MTHD_CHNG_PYMT", loginId:string|null = null) => {
    try {
        const tokenResp = await MbpAthnTknCrtRqstApi(athnPrpsCd, loginId);
        if(tokenResp.apiHdr.code !== "ATHN0000") {
            // alert(`${tokenResp.apiHdr.msg}`);
            return;
        }

        const reqKMCISForm = document.createElement("form");
        reqKMCISForm.method = "post";
        reqKMCISForm.action = "https://www.kmcert.com/kmcis/web/kmcisReq.jsp";
        reqKMCISForm.style.display = "none";

        const trCertInput = document.createElement("input");
        trCertInput.type = "hidden";
        trCertInput.name = "tr_cert";
        trCertInput.value = tokenResp.apiBody.kmcTkn;

        const trUrlInput = document.createElement("input");
        trUrlInput.type = "hidden";
        trUrlInput.name = "tr_url";
        trUrlInput.value = `${process.env.REACT_APP_KMC_REDIRECT_URL}`;

        const trVerInput = document.createElement("input");
        trVerInput.type = "hidden";
        trVerInput.name = "tr_ver";
        trVerInput.value = "V2";

        reqKMCISForm.appendChild(trCertInput);
        reqKMCISForm.appendChild(trUrlInput);
        reqKMCISForm.appendChild(trVerInput);
        document.body.appendChild(reqKMCISForm);

        if(useInlinePaymentFlow) {
            reqKMCISForm.target = "";
        }else {
            const KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
            if(KMCIS_window == null){
                // alert(" ???�도??XP SP2 ?�는 ?�터???�스?�로??7 ?�용?�일 경우?�는 \n    ?�면 ?�단???�는 ?�업 차단 ?�림줄을 ?�릭?�여 ?�업???�용??주시�?바랍?�다. \n\n??MSN,?�후,구�? ?�업 차단 ?�바가 ?�치??경우 ?�업?�용???�주?�기 바랍?�다.");
                document.body.removeChild(reqKMCISForm);
                return;
            }
            reqKMCISForm.target = "KMCISWindow";
        }

        reqKMCISForm.submit();
        document.body.removeChild(reqKMCISForm);
    }catch(error:any) {
        alert(error?.message || "본인인증 진행 중 오류가 발생하였습니다.");
    }
}

const handleDpstOdrCrdtResp = (resp:any, onSuccess:() => void) => {
    switch(resp.apiHdr.code) {
        case "PYMT0000":
            onSuccess();
        break;
        case "PYMT3526":
            emitDpstApiMessage("PYMT3526", `${resp.apiHdr.msg || "결제 처리 중 오류가 발생했습니다."}`);
        break;
        case "ATHN2008":
            if(resp.apiBody?.param === "MBP") {
                alert(resp.apiBody?.msg);
                openMbpAthnWindow( "MTHD_CHNG_PYMT", null);
                break;
            }else {
                alert(resp.apiBody?.msg);
                if(window.opener && !window.opener.closed && typeof window.opener.OpenrReplaceFunc === "function") {
                    window.opener.OpenrReplaceFunc("/MyPage");
                    window.close();
                    break;
                }
                if(!navigateByService("/MyPage", { replace: true })) {
                    window.location.href = "/MyPage";
                }
            }
        break;
        case "ATHN2128" :
            openMbpAthnWindow( "PRNT_ATHN_PYMT", null);
        break;
        default:
            alert(`${resp.apiHdr.msg}`);
        break;
    }
}

// ?�이버페??
const NaverDpstOdrCrdtFunc= (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    let oPay:any;
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                oPay = window.Naver.Pay.create({ 
                    "mode" : resp.apiBody.rqstJson.crtJson.mode,
                    "clientId": resp.apiBody.rqstJson.crtJson.clientId,
                    "chainId" : resp.apiBody.rqstJson.crtJson.chainId,
                });
                oPay.open({
                    "merchantUserKey": resp.apiBody.rqstJson.openJson.merchantUserKey,
                    "merchantPayKey": resp.apiBody.rqstJson.openJson.merchantPayKey,
                    "productName": resp.apiBody.rqstJson.openJson.productName,
                    "totalPayAmount": resp.apiBody.rqstJson.openJson.totalPayAmount,
                    "taxScopeAmount": resp.apiBody.rqstJson.openJson.taxScopeAmount,
                    "taxExScopeAmount": resp.apiBody.rqstJson.openJson.taxExScopeAmount,
                    "returnUrl": resp.apiBody.rqstJson.openJson.returnUrl,
                    "purchaserName": resp.apiBody.rqstJson.openJson.purchaserName,
                    "purchaserBirthday":resp.apiBody.rqstJson.openJson.purchaserBirthday,
                    "productItems" : resp.apiBody.rqstJson.openJson.productItems,
                    "productCount" : resp.apiBody.rqstJson.openJson.productCount,
                });
            });
        })
}
// 카카?�페??
const KakaoDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                const kakaoPcUrl = resp?.apiBody?.rqstJson?.resp?.next_redirect_pc_url;
                const kakaoMobileUrl = resp?.apiBody?.rqstJson?.resp?.next_redirect_mobile_url;
                const kakaoRedirectUrl = isMobile
                    ? (kakaoMobileUrl || kakaoPcUrl)
                    : (kakaoPcUrl || kakaoMobileUrl);
                if (!kakaoRedirectUrl) {
                    // alert("결제 페이지 URL을 찾을 수 없습니다.");
                    return;
                }

                openPaymentUrl(kakaoRedirectUrl, "KakaoPayWindow");
            });
        })
    )
}
// 빌게?�트 - 카드
const CreditcardDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
        
    )
}
// 빌게?�트 - 카카?�페??
const  BkakaoDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
        
    )
}
// 빌게?�트 - 카카?�페??
const  BnaverDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
        
    )
}
// 빌게?�트 - 카카?�페??
const  BtossDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string, 
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
        
    )
}
// 빌게?�트 - ?��???결제
const MobilepymtDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// 빌게?�트 - ?�시�?계좌 ?�체
const RltmacctDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// 빌게?�트 - ?�서?�품�?
const GiftbookDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// 빌게?�트 - 문화?�품�?
const GiftcltrDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// 빌게?�트 - ?�피머니?�품�?
const GifthppyDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// 빌게?�트 - ?�마?�문??
const GiftsmrtDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                jsonToFormData(resp.apiBody.rqstJson);
                window.GX_pay("payment", BILLGATE_VIEW_TYPE, BILLGATE_TARGET);
            });
        })
    )
}
// Xsolla
const XsollaDpstOdrCrdtFunc = (
    gameSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string   ,
    dpstPrdtCd:string   ,
    dpstPrdtCnt:number  ,
    dpstOdrMny:string   ,
    prdtPrc:string,
    pgCd:string,
    rcmnPrdtCd?:string
) => {
    return(
        DpstOdrCrdtApi(gameSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrc,pgCd,rcmnPrdtCd)
        .then((resp)=>{
            handleDpstOdrCrdtResp(resp, () => {
                const xsollaUrl = resp?.apiBody?.rqstJson?.url;
                if (!xsollaUrl) {
                    return;
                }

                openPaymentUrl(xsollaUrl, "XsollaPayWindow");
                
            });
        })
    )
}
const jsonToFormData = (jsonData:any) => {
    const SERVICE_ID:any = document.getElementById("SERVICE_ID");
    const SERVICE_CODE:any = document.getElementById("SERVICE_CODE");
    const SERVICE_TYPE:any = document.getElementById("SERVICE_TYPE");
    const ORDER_ID:any = document.getElementById("ORDER_ID");
    const ORDER_DATE:any = document.getElementById("ORDER_DATE");
    const AMOUNT:any = document.getElementById("AMOUNT");
    const RETURN_URL:any = document.getElementById("RETURN_URL");
    const ITEM_CODE:any = document.getElementById("ITEM_CODE");
    const ITEM_NAME:any = document.getElementById("ITEM_NAME");
    const USER_ID:any = document.getElementById("USER_ID");
    const USER_NAME:any = document.getElementById("USER_NAME");
    const USER_EMAIL:any = document.getElementById("USER_EMAIL");
    const RESERVED1:any = document.getElementById("RESERVED1");
    const RESERVED2:any = document.getElementById("RESERVED2");
    const RESERVED3:any = document.getElementById("RESERVED3");
    const CANCEL_FLAG:any = document.getElementById("CANCEL_FLAG");
    const WEBAPI_FLAG:any = document.getElementById("WEBAPI_FLAG");
    const LOGO:any = document.getElementById("LOGO");
    const INSTALLMENT_PERIOD:any = document.getElementById("INSTALLMENT_PERIOD");
    const PAY_TYPE:any = document.getElementById("PAY_TYPE");
    const HASH_KEY:any = document.getElementById("HASH_KEY");
    
    SERVICE_ID.value = jsonData.SERVICE_ID;
    SERVICE_CODE.value = jsonData.SERVICE_CODE;
    SERVICE_TYPE.value = jsonData.SERVICE_TYPE;
    ORDER_ID.value = jsonData.ORDER_ID;
    ORDER_DATE.value = jsonData.ORDER_DATE;
    AMOUNT.value = jsonData.AMOUNT;
    RETURN_URL.value = jsonData.RETURN_URL;
    ITEM_CODE.value = jsonData.ITEM_CODE;
    ITEM_NAME.value = jsonData.ITEM_NAME;
    USER_ID.value = jsonData.USER_ID;
    USER_NAME.value = jsonData.USER_NAME;
    USER_EMAIL.value = jsonData.USER_EMAIL;
    RESERVED1.value = jsonData.RESERVED1;
    RESERVED2.value = jsonData.RESERVED2;
    RESERVED3.value = jsonData.RESERVED3;
    CANCEL_FLAG.value = jsonData.CANCEL_FLAG;
    WEBAPI_FLAG.value = jsonData.WEBAPI_FLAG;
    LOGO.value = jsonData.LOGO;
    INSTALLMENT_PERIOD.value = jsonData.INSTALLMENT_PERIOD;
    HASH_KEY.value = jsonData.HASH_KEY;
    if(PAY_TYPE && jsonData.PAY_TYPE) {
        PAY_TYPE.value = jsonData.PAY_TYPE;
    }


};

const DpstOdrCrdtFunc=(
    selectedSvcCd:string,
    pymtMthdCd:string,
    prdtKindCd:string,
    dpstPrdtCd:string,
    dpstPrdtCnt:number,
    dpstOdrMny:string,
    prdtPrcState:string,
    pgCdState:string,
    rcmnPrdtCd?:string,
)=> {
    switch(pymtMthdCd) {
        case"NAVERPAY":
        NaverDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"KAKAOPAY":
        KakaoDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"BNAVERPAY":
        BnaverDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"BKAKAOPAY":
        BkakaoDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"CREDITCARD":
        CreditcardDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"MOBILEPYMT":
        MobilepymtDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case "BTOSSPAY":
        BtossDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"RLTMACCT":
        RltmacctDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"GIFTBOOK":
        GiftbookDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"GIFTCLTR":
        GiftcltrDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"GIFTHPPY":
        GifthppyDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"GIFTSMRT":
        GiftsmrtDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
        case"XSOLLA":
        XsollaDpstOdrCrdtFunc(selectedSvcCd,pymtMthdCd,prdtKindCd,dpstPrdtCd,dpstPrdtCnt,dpstOdrMny,prdtPrcState,pgCdState,rcmnPrdtCd);
        break;
    }
}
export {
    NaverDpstOdrCrdtFunc        ,
    KakaoDpstOdrCrdtFunc        ,
    CreditcardDpstOdrCrdtFunc   ,
    GiftbookDpstOdrCrdtFunc     ,
    MobilepymtDpstOdrCrdtFunc   ,
    RltmacctDpstOdrCrdtFunc     ,
    XsollaDpstOdrCrdtFunc       ,
    GifthppyDpstOdrCrdtFunc     , 
    GiftsmrtDpstOdrCrdtFunc     ,
    GiftcltrDpstOdrCrdtFunc     ,
    BkakaoDpstOdrCrdtFunc       ,
    BtossDpstOdrCrdtFunc        ,
    BnaverDpstOdrCrdtFunc       ,
    DpstOdrCrdtFunc
};


